import YouTubeIframeLoader from 'youtube-iframe';

export default class Video {
    constructor(component) {
        const root = this;

        this.component = component;
        this.youtubeUrl = this.component.getAttribute('data-video-url');
        this.youtubeId = this.getYoutubeId();
        this.youtubeFrame = this.component.querySelector('[data-video-frame]');
        this.videoImage = this.component.querySelector('[data-video-image]');
        this.playButton = this.component.querySelector('[data-video-play]');
        this.videoInModal = this.component.hasAttribute('data-video-in-modal') ? true : false;
        
        this.iframe = null;
        this.videoElement = null;

        if (this.youtubeId && this.playButton) {
            this.playButton.addEventListener('click', () => {
                this.create(root);
            })
        }

        if (this.videoInModal) {
            const videoModal = this.component.closest('.modal');
            const modalclosers = videoModal.querySelectorAll(`[data-modal-close="#${videoModal.id}"]`);

            modalclosers.forEach(item => {
                item.addEventListener('click', () => {
                    this.destroy(root)
                });
            });

            this.backdropElement = document.querySelector('.backdrop');
            
            this.backdropElement.addEventListener('click', () => {
                this.destroy(root)
            });
        }
    }

    getYoutubeId() {
        if (!this.youtubeUrl) return;

        return this.youtubeUrl.substr(this.youtubeUrl.indexOf('?v=') + 3);
    }

    create(root) {
        YouTubeIframeLoader.load(function(YT) {
            root.videoElement = new YT.Player(root.youtubeFrame.id, {
                height: '1600',
                width: '1280',
                videoId: root.youtubeId,
                events: {
                    'onReady': root.onPlayerReady
                }
            });

            root.component.classList.add('is-playing');
        });

        setTimeout(() => {
            root.iframe = this.component.querySelector('iframe');
        }, 500);
    }

    destroy(root) {
        if (root.iframe) {
            root.iframe.insertAdjacentHTML('afterend', `<div id="${root.youtubeFrame.id}" data-video-frame></div>`);
            root.iframe.remove();
        }
    }

    onPlayerReady(event) {
        event.target.playVideo();
    }
}